export const messages = {
  labels: {
    startDate: {
      id: 'treatmentSummary.Groups.Surgery.StartDate',
      defaultMessage: 'Date: ',
    },
    laterality: {
      id: 'treatmentSummary.Groups.Surgery.Laterality',
      defaultMessage: 'Side: ',
    },
    provider: {
      id: 'treatmentSummary.Groups.Surgery.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.Surgery.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.Surgery.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.Surgery.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.Surgery.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
